<template>
    <base-button
        type="button"
        :class="{'uk-active': !!value}"
        class="uk-button uk-button-link uk-button-mini"
        @click.prevent.stop="toggle"
    >
        <open-icon :glyph="!!value ? 'star' : 'star-o'" />
    </base-button>
</template>

<script>
import BaseButton from "./BaseButton"
import OpenIcon from "./OpenIcon"

export default {
    components: {
        BaseButton,
        OpenIcon
    },
    methods: {
        toggle () {
            this.$emit("input", !this.value, this.name)
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: false
        }
    }
}
</script>
